import { gql } from '@apollo/client';

export const GET_SKILLS_BY_FILTER_QUERY = gql`
  query GET_SKILLS_BY_FILTER_QUERY($filter: String!) {
    getSkillsByFilter(filter: $filter) {
      value: id
      label: name
    }
  }
`;
